export default __webpack_public_path__ + "city-map-500-56f5f18e320913ce7009732285344e0c.webp";